<form [formGroup]="form" class="flex flex-col gap-5">
  <div class="flex flex-col gap-3">
    <pm-h3 elementClass="text-sm font-bold text-content-interactive-subdued">
      {{ 'ANALYSIS.CREATE_CONFIGURATION.SELECT_MEASURES' | translate }}
    </pm-h3>
    <p
      class="text-sm text-content-interactive-subdued"
      [innerHTML]="
        'ANALYSIS.CREATE_CONFIGURATION.ERROR_MEASURES_STEP_DESCRIPTION'
          | translate
      "
    ></p>
  </div>

  <pm-tabs-group
    size="normal"
    dataTestidPrefix="measure-variant"
    [options]="variantTabs"
    [queryKey]="undefined"
    [fullWidth]="true"
    (handleClick)="onTabChange($event)"
  />

  <div class="grid">
    @for (panel of measurePanels(); track panel.tab) {
      @let isActivePanel = panel.tab === selectedTab();
      <div
        class="col-start-1 row-start-1 grid grid-cols-3 items-start gap-6"
        [class.invisible]="!isActivePanel"
        [attr.inert]="isActivePanel ? null : ''"
      >
        @for (category of panel.categories; track category.labelKey) {
          <div class="flex flex-col gap-4">
            <span class="text-sm text-content-subdued">
              {{ category.labelKey | translate }}
            </span>
            @for (checkbox of category.checkboxes; track checkbox.controlName) {
              <pm-form-input-checkbox [formControlName]="checkbox.controlName">
                <span class="text-sm text-content-default">
                  {{ checkbox.label }}
                </span>
              </pm-form-input-checkbox>
            }
          </div>
        }
      </div>
    }
  </div>

  <div class="flex flex-col gap-3 mt-3">
    <pm-h3 elementClass="text-sm font-bold text-content-interactive-subdued">
      {{ 'ANALYSIS.CREATE_CONFIGURATION.CALCULATION_LEVEL_TITLE' | translate }}
    </pm-h3>

    <div class="grid grid-cols-2 items-stretch gap-4">
      @for (level of calculationLevels; track level.value) {
        <pm-selection-card
          [title]="level.titleKey"
          [description]="level.descriptionKey"
          [selected]="form.controls.calculationLevel.value === level.value"
          (handleSelect)="onCalculationLevelChange(level.value)"
        />
      }
    </div>
  </div>
</form>
